/**
 * A date as its LOCAL calendar day, YYYY-MM-DD — the form `start_date` /
 * `due_date` are stored and compared in. Kept free of date-fns so the PM store
 * (which stamps a new draft's start date with it) does not load the whole
 * library just to format today.
 */
export function toISODate(d: Date): string {
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}
